import { render, staticRenderFns } from "./AddWin.vue?vue&type=template&id=22586b2f&scoped=true"
import script from "./AddWin.vue?vue&type=script&lang=js"
export * from "./AddWin.vue?vue&type=script&lang=js"
import style0 from "./AddWin.vue?vue&type=style&index=0&id=22586b2f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22586b2f",
  null
  
)

export default component.exports